// src/components/Sections/HomeHelmet/HomeHelmet.jsx

import React from 'react';
import { Helmet } from 'react-helmet';

export default function HomeHelmet({ siteUrl }) {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Is The Tour Golfers a private club?',
        acceptedAnswer: {
          '@type': 'Answer',
          text:
            'No. The Tour Golfers is a technology-enabled membership built for public golfers. Members continue playing the public courses they already enjoy while belonging to a broader golf community.'
        }
      },
      {
        '@type': 'Question',
        name: 'What does membership include?',
        acceptedAnswer: {
          '@type': 'Answer',
          text:
            'Membership provides access to The Tour Golfers platform and community, including scoring, GPS, golf history, Apple Watch support, friends, groups, tournaments, leaderboards, and member participation opportunities.'
        }
      },
      {
        '@type': 'Question',
        name: 'What makes The Tour Golfers different from other golf apps?',
        acceptedAnswer: {
          '@type': 'Answer',
          text:
            'Most golf technology focuses on tracking or improving the individual round. The Tour Golfers uses practical golf technology as the foundation for an ongoing public-golf membership built around groups, competition, events, relationships, and community.'
        }
      },
      {
        '@type': 'Question',
        name: 'Where is The Tour Golfers launching?',
        acceptedAnswer: {
          '@type': 'Answer',
          text:
            'The Tour Golfers is beginning in the Greater Toronto Area and Southern Ontario, with a strategy focused on building strong local membership before expanding city by city.'
        }
      }
    ]
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'The Tour Golfers',
    url: siteUrl,
    logo: `${siteUrl}/logo192.png`,
    description:
      'A technology-enabled golf membership and Digital Country Club built for public golfers.'
  };

  const productSchema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: 'The Tour Golfers Founding Membership',
    description:
      'An annual public-golf membership combining score tracking, GPS, Apple Watch support, groups, tournaments, events, and community.',
    brand: {
      '@type': 'Brand',
      name: 'The Tour Golfers'
    },
    offers: {
      '@type': 'Offer',
      price: '39.99',
      priceCurrency: 'CAD',
      url: `${siteUrl}/#pricing`,
      availability: 'https://schema.org/PreOrder'
    }
  };

  return (
    <Helmet>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1"
      />

      <title>
        The Digital Country Club for Public Golfers | The Tour Golfers
      </title>

      <meta
        name="description"
        content="The Tour Golfers is a modern golf membership for public golfers. Track rounds, use GPS and Apple Watch, compete with friends, join groups and events, and belong wherever you play."
      />

      <link
        rel="canonical"
        href={`${siteUrl}/`}
      />

      <meta
        property="og:title"
        content="A Country Club Without Walls | The Tour Golfers"
      />

      <meta
        property="og:description"
        content="A modern golf membership built for public golfers — combining practical golf technology, groups, competition, events, and community."
      />

      <meta
        property="og:image"
        content={`${siteUrl}/og-image.jpg`}
      />

      <meta
        property="og:url"
        content={`${siteUrl}/`}
      />

      <meta
        property="og:type"
        content="website"
      />

      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      <meta
        name="twitter:title"
        content="A Country Club Without Walls | The Tour Golfers"
      />

      <meta
        name="twitter:description"
        content="A modern golf membership built for public golfers — track your golf, connect with others, compete, attend events, and belong wherever you play."
      />

      <meta
        name="twitter:image"
        content={`${siteUrl}/og-image.jpg`}
      />

      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>

      <script type="application/ld+json">
        {JSON.stringify(productSchema)}
      </script>

      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
    </Helmet>
  );
}